import "font-awesome/scss/font-awesome.scss";

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import App from "@/analytics/App.vue";
import router from "@/router/router-ANALYTICS";
import store from "@/store";

import Vue from "vue";

import GoogleAnalytics from "@/plugins/google-analytics/index";

import NumberFilter from "@/filters/number";

import { SET_CACHE_AUTH } from "@/store/mutation-types";

import { adminConsoleNotice } from "@/utils/admin";

adminConsoleNotice();

Vue.config.productionTip = false;

// Automatic Global Registration of `Base*` components
const requireComponent = require.context("@/components", false, /Base[A-Z]\w+\.(vue|ts)$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1")));
  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.use(GoogleAnalytics);

Vue.filter("number", NumberFilter);
new Vue({
  router,
  store,
  created() {
    // auto-login user
    const token = localStorage.getItem("token");
    if (token) {
      this.$store.commit(SET_CACHE_AUTH, token);
    }
  },
  render: h => h(App),
}).$mount("#app");
